import { ApiGetResponse, ApiRequest } from 'app/common/types'

interface DatePeriodGetContent {
  fromDate: string
  toDate: string
}

interface ConversionEntity {
  conversionCount: number
  conversionCountByEvent: Record<string, number>
  date: string
}

export type ConversionsGetRequest = ApiRequest<DatePeriodGetContent>
export type ConversionsResponse = ApiGetResponse<ConversionEntity[]>

export type Conversions = Record<string, number>

export const mapToConversions = (conversionEntities: ConversionEntity[]): Conversions =>
  conversionEntities.reduce((acc, conversionEntity) => {
    Object.entries(conversionEntity.conversionCountByEvent).forEach(([eventName, count]) => {
      if (acc[eventName]) {
        acc[eventName] += count
      } else {
        acc[eventName] = count
      }
    })

    return acc
  }, {} as Conversions)
